// extracted by mini-css-extract-plugin
export default {"days":"plain-calendar_days__mF7mB","weekdays":"plain-calendar_weekdays__fChyY","placeHolderShimmer":"plain-calendar_placeHolderShimmer__IrElP"};